import {
  ACTION_EDIT_WEBMASTER_PROFILE__REQUEST,
  ACTION_EDIT_WEBMASTER_PROFILE__SUCCESS,
  ACTION_EDIT_WEBMASTER_PROFILE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_EDIT_WEBMASTER_PROFILE__REQUEST:
    case ACTION_EDIT_WEBMASTER_PROFILE__SUCCESS:
      return null;

    case ACTION_EDIT_WEBMASTER_PROFILE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
